import React from 'react'
import dynamic from 'next/dynamic'

const ContactForm = dynamic(() => import('@components/ContactForm'), {
  ssr: false,
})

const GetStarted = () => {
  return (
    <div className='GetStarted'>
      <div className='container'>
        <h2>สอบถามเพิ่มเติม</h2>

        <div className='GetStarted__form'>
          <ContactForm />
        </div>
      </div>
    </div>
  )
}

export default GetStarted
